module.exports = __webpack_public_path__ + "static/media/ic_visa_master_card.8293ee83.svg";